/* eslint-disable react/prop-types */
import React from 'react';

import { translate } from '~l10n/client';

import CloseX from 'CloseX';
import Constants from 'Constants';
import Input from 'Input';

export default class RenameRoomView extends React.Component {
  componentDidMount() {
    let nameInput = document.getElementById('roomName');

    if (nameInput) {
      nameInput.select();
      nameInput.focus();
    }
  }

  render() {
    let c = this.props.controller;
    let m = this.props.model;

    return (
      <div id="rename-room-modal-background" className="modal open">
        <div id="rename-room-modal-box" className="modal-dialog">
          <div className="modal-header">
            <span className="popup-title">{translate('Rename Room')}</span>
            <div className="cancel-button" onClick={c.cancelClicked}>
              <CloseX className="cancel-button-x" color="#cccccc" />
            </div>
          </div>
          <div id="rename-room-modal-content" className="form">
            <Input
              id="roomName"
              label={translate('Room Name')}
              maxLength={Constants.MAX_ROOM_NAME_LENGTH}
              status={m.nameStatus}
              tooltipLocation="above"
              value={m.name}
              onChange={(event) => c.nameChanged(event.target.value)}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  c.renameClicked();
                }
              }}
            />
            <div className="rename-room-buttons-container">
              <button
                id="renameRoomButton"
                className="rename-room-button"
                onClick={c.renameClicked}
              >
                {translate('Rename', true)}
              </button>
              <button
                className="rename-room-button rename-room-cancel-button"
                onClick={c.cancelClicked}
              >
                {translate('Cancel', true)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
